var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-4 mb-4 account_deletion_alert_btn",attrs:{"fab":"","dark":"","color":"error","to":{name: 'Account'}}},[_c('v-icon',{attrs:{"dark":"","large":""}},[_vm._v("mdi-exclamation")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }